import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid, ImageList, ImageListItem, ImageListItemBar, Stack, Typography } from '@mui/material';
import React, { SetStateAction } from 'react';
import FileUpload from '../presentation-components/miscellaneous-components/file-upload';
import FileUploadService from '../../shared/services/file-upload/file-upload.service';
import { FileThumbnail } from '../../shared/utils/file-type-icons';

export const FileSelectorDialog: React.FC<{
  dialogActive: boolean,
  cancelUpload: any,
  fileData: any,
  setFileData: any,
  submitHandler: React.Dispatch<SetStateAction<any>>,
  allowedFileTypes?: string[],
}> = (
  {
    dialogActive,
    cancelUpload,
    fileData,
    setFileData,
    submitHandler,
    allowedFileTypes
  }
) => {

    const fileUploadService = new FileUploadService()

    const storeData = async (file: any) => {
      setFileData([...fileData, file]);
    };

    const handleCancelUpload = () => {
      setFileData([]);
      cancelUpload();
    }

    const getBlobImageUrl = (index: number) => {
      return URL.createObjectURL(fileData[index]);
    }

    const isImageFile = (file: File) => {
      return file.type.startsWith('image/');
    }

    // This needs to be change to listen for errors. For the moment it will stop double clicking if the image takes a few seconds to upload.
    // const setUploadSpinner = () => {
    //   setIsUploading(true);

    //   setTimeout(() => {
    //     setIsUploading(false);
    //   }, 4000);
    // }

    return (
      <Dialog open={dialogActive} maxWidth='md' fullWidth>
        <Box sx={{ p: 4 }} component="form"
          noValidate
          autoComplete="off"
          onSubmit={submitHandler}>
          <DialogTitle sx={{ pt: 0, pl: 0, pr: 0 }}>Add a Resource</DialogTitle>
          <DialogContent sx={{ pt: 0, pl: 0, pr: 0 }}>
            <DialogContentText sx={{ color: 'text.primary' }}>
              Upload new resources using the form below
            </DialogContentText>
            <Grid item xs={12} md={12} lg={12} sx={{ mt: "16px" }}>
              <FileUpload
                csv={false}
                handleFileUpload={storeData}
                allowedFileTypes={allowedFileTypes}
              />
            </Grid>
          </DialogContent>
          <DialogActions>
            <Stack direction='row' spacing={1}>
              <Button variant='text' onClick={() => handleCancelUpload()}><Typography sx={{ p: 0.5 }}>Cancel</Typography></Button>
              <Button type='submit'
                disabled={fileData.length === 0}
                disableElevation
                // onClick={() => [completeUpload(), setUploadSpinner()]}
                sx={{ minWidth: '100px' }}
              >
                <Typography>
                  Upload
                  {/* {isUploading ? <CircularProgress size={14} /> : 'Upload'} */}
                </Typography>
              </Button>
            </Stack>
          </DialogActions>
          {fileData.length > 0 &&
            <DialogContent sx={{ pt: 0, pl: 0, pr: 0 }}>
              <Box sx={{ display: 'flex', flexDirection: 'row', gap: 3, alignItems: 'center', flexWrap: 'wrap' }}>
                {fileData.map((file: File, index: number) => {
                  return (
                    <Box sx={{
                      maxWidth: '140px',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      textAlign: 'center'
                    }} key={index}>
                      <FileThumbnail
                        file={file}
                        width={120}
                        height={120}
                        sx={{
                          border: '1px solid',
                          borderColor: 'grey.300'
                        }}
                      />
                    </Box>
                  )
                })}
              </Box>
            </DialogContent>}
        </Box>
      </Dialog>
    )
  }